<div class="edit-incident-modal" *transloco="let t; prefix: 'accidents.modals.editIncident'">
  <div class="edit-incident-modal__header">
    <h3 class="edit-incident-modal__title">{{ t('title') }}</h3>
    <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="cancel()" [disabled]="isSaving">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
        </path>
      </svg>
    </button>
  </div>

  <form [formGroup]="editForm" class="edit-incident-modal__form">
    <div class="form-step">
      <div class="form-row">
        <div class="form-group">
          <label class="form-label">{{ t('assetName') }}</label>
          <input
            type="text"
            formControlName="assetName"
            class="form-control disabled-input">
        </div>

        <div class="form-group">
          <label class="form-label">{{ t('driver') }}</label>
          <input
            type="text"
            formControlName="driver"
            class="form-control disabled-input">
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label class="form-label">{{ t('location') }}</label>
          <input
            type="text"
            formControlName="location"
            class="form-control disabled-input">
        </div>

        <div class="form-group">
          <label class="form-label">{{ t('dateAndTime') }}</label>
          <input
            type="text"
            formControlName="dateTime"
            class="form-control disabled-input">
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label class="form-label">{{ t('incidentType') }}</label>
          <div ngbDropdown class="dropdown-wrapper" [autoClose]="true" placement="bottom-start" container="body">
            <button type="button" class="form-control dropdown-toggle" ngbDropdownToggle #incidentTypeToggle>
              <div class="dropdown-inner">
                <span [class.placeholder]="!selectedIncidentType">{{ incidentTypeLabel }}</span>
                <i class="ph ph-caret-down"></i>
              </div>
            </button>
            <div ngbDropdownMenu class="dropdown-menu edit-incident-dropdown-menu" [style.width.px]="incidentTypeToggle.offsetWidth">
              @for (type of incidentTypes; track type.id) {
                <button type="button" class="dropdown-item" (click)="onIncidentTypeSelect(type)" ngbDropdownItem>
                  {{ type.localizedName || type.name }}
                </button>
              }
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">{{ t('severity') }}</label>
          <div ngbDropdown class="dropdown-wrapper" [autoClose]="true" placement="bottom-start" container="body">
            <button type="button" class="form-control dropdown-toggle" ngbDropdownToggle #severityToggle>
              <div class="dropdown-inner">
                <span [class.placeholder]="!selectedSeverity">{{ severityLabel }}</span>
                <i class="ph ph-caret-down"></i>
              </div>
            </button>
            <div ngbDropdownMenu class="dropdown-menu edit-incident-dropdown-menu" [style.width.px]="severityToggle.offsetWidth">
              @for (severity of severities; track severity) {
                <button type="button" class="dropdown-item" (click)="onSeveritySelect(severity)" ngbDropdownItem>
                  {{ severityLabelKeys[severity] | transloco }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">{{ t('description') }}</label>
        <textarea
          formControlName="description"
          class="form-control textarea"
          [placeholder]="t('descriptionPlaceholder')"
          rows="4">
        </textarea>
      </div>

      <div class="form-group">
        <label class="form-label">{{ t('witnessDetails') }}</label>
        <textarea
          formControlName="witnessDetails"
          class="form-control textarea disabled-input"
          [placeholder]="t('witnessDetailsPlaceholder')"
          rows="4">
        </textarea>
      </div>
    </div>
  </form>

  <div class="edit-incident-modal__actions">
    <button type="button" class="btn-cancel" (click)="cancel()">
      <span>{{ 'common.cancel' | transloco }}</span>
    </button>
    <button type="button" class="btn-save" (click)="save()" [disabled]="!canSave">
      <span>{{ isSaving ? t('saving') : t('save') }}</span>
    </button>
  </div>
</div>